const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTdhMiAyIDAgMSAxIDAgNCAyIDIgMCAwIDEgMC00em0wLTdhMiAyIDAgMSAxIDAgNCAyIDIgMCAwIDEgMC00em0wLTdhMiAyIDAgMSAxIDAgNCAyIDIgMCAwIDEgMC00eiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=elipsis_vertical-e6c9d8ff.mjs.map
